import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { MESSAGE_INPUT_SPACING } from "../../Chat/constants";
import { IconButton } from "../components/IconButton";

interface EditingMessageIndicatorProps {
  onCancel: () => void;
}

export function EditingMessageIndicator(props: EditingMessageIndicatorProps) {
  const { onCancel } = props;

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      paddingX={MESSAGE_INPUT_SPACING}
      paddingTop={MESSAGE_INPUT_SPACING}
    >
      <Text semibold>Editing message</Text>
      <IconButton iconType="close" variant="ghost" onClick={onCancel} />
    </Stack>
  );
}
